import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./smallCalendar.css"

const SmallCalendar = () => {
  const [date, setDate] = useState(new Date());

  return (
    <div className="calendar-container">
      <Calendar
        onChange={setDate}
        value={date}
        className="small-calendar"
      />
      {/* <p>Selected Date: {date.toDateString()}</p> */}
    </div>
  );
};

export default SmallCalendar;